var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSpeechPause = function SvgSpeechPause(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 70 70"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.51 69.06c19.06 0 34.51-15.45 34.51-34.51S53.57.04 34.51.04 0 15.49 0 34.55s15.45 34.51 34.51 34.51"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M27.49 17.69h-.8a4 4 0 0 0-4 4v25.64a4 4 0 0 0 4 4h.8a4 4 0 0 0 4-4V21.69a4 4 0 0 0-4-4M42.34 17.69h-.8a4 4 0 0 0-4 4v25.64a4 4 0 0 0 4 4h.8a4 4 0 0 0 4-4V21.69a4 4 0 0 0-4-4"
  })));
};
export default SvgSpeechPause;